<script lang="ts">
    import type {DurationItem} from '../types';
    import {exists} from 'shared/utils/custom-utils';
    import {formatAbsenceReasons, formatDurationStringToHours, isAbsenceDurationItem} from '../utils';

    export let durationItem: DurationItem;
</script>

{#if exists(durationItem)}
    {formatDurationStringToHours(durationItem.duration)}

    {#if isAbsenceDurationItem(durationItem)}
        <br/>
        {formatAbsenceReasons(durationItem.reasons)}
    {/if}
{/if}